import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container, Typography } from "@mui/material";

import MainView from "./components/MainView";
import Footer from "./components/Footer";
import NavBar from "./components/NavBar";
import PostDetail from "./components/PostDetail";
import PostsViews from "./components/PostsView";
import SocialMediaBar from "./components/SocialMediaBar";
import AlbumViewer from "./components/AlbumViewer";
import SmugMugGallery from "./components/SmugMugGallery";
import Podcast from "./components/Podcast";
import CommunityView from "./components/CommunityView";
import PaceCalculator from "./components/PaceCalculator";
import TrainingPlanView from "./components/TrainingPlanView";

// Placeholder components for new sections
const Stories = () => <Container sx={{py: 4}}><Typography variant="h4">Stories</Typography><Typography>Coming soon...</Typography></Container>;
const About = () => <Container sx={{py: 4}}><Typography variant="h4">About</Typography><Typography>Coming soon...</Typography></Container>;

function App() {
  return (
    <div>
      <NavBar />
      <SocialMediaBar />
      <main>
        <Routes>
          <Route path='/' element={<MainView />} />
          <Route path='/blog' element={<PostsViews />} />
          <Route path='/photos' element={<SmugMugGallery />} />
          <Route path='/photos/:albumKey' element={<AlbumViewer />} />
          <Route path='/podcast' element={<Podcast />} />
          <Route path='/community' element={<CommunityView />} />
          <Route path='/stories' element={<Stories />} />
          <Route path='/about' element={<About />} />
          <Route path='/detail/:id' element={<PostDetail />} />
          <Route path='/pace-calculator' element={<PaceCalculator />} />
          <Route path='/training' element={<TrainingPlanView />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;